// @flow

// Vendors
import React from 'react';
import classnames from 'classnames';

// types
import { InputCheckboxType } from '../../../types';

const InputCheckbox = ({ label, checked, ...props }: InputCheckboxType) => (
  <label className="form__checkbox" htmlFor={props.id}>
    <input
      {...props}
      type="checkbox"
      checked={typeof checked !== 'undefined' ? checked : props.value}
    />
    {label}
  </label>
);

export default InputCheckbox;
